import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MapPin3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.5 1C9.16568 1 4.00677 6.3584 4.00001 12.9449C3.99443 18.9798 6.64224 20.6775 14.9145 30.7175C15.2205 31.0897 15.7833 31.0994 16.0984 30.7151C24.344 20.6315 27 19.0415 27 12.9578C27 6.36426 21.8411 1 15.5 1ZM15.5 22.7469C10.3873 22.7469 6.22812 18.4221 6.22812 13.106C6.22812 7.78984 10.3873 3.46445 15.5 3.46445C20.6127 3.46445 24.7719 7.78984 24.7719 13.106C24.7719 18.4221 20.6127 22.7469 15.5 22.7469Z"
        fill="currentColor"
      />
      <path
        d="M15.5 5.22226C11.3193 5.22226 7.91864 8.75898 7.91864 13.106C7.91864 17.4525 11.3194 20.9891 15.5 20.9891C19.6806 20.9891 23.0814 17.4524 23.0814 13.106C23.0814 8.75892 19.6807 5.22226 15.5 5.22226ZM18.8444 16.8613C18.8444 17.347 18.4663 17.7402 17.9992 17.7402C17.5326 17.7402 17.1539 17.347 17.1539 16.8613V13.856H13.8461V16.8613C13.8461 17.347 13.4674 17.7402 13.0009 17.7402C12.5337 17.7402 12.1556 17.347 12.1556 16.8613V9.35013C12.1556 8.86498 12.5337 8.47123 13.0009 8.47123C13.4674 8.47123 13.8461 8.86498 13.8461 9.35013V12.0982H17.1539V9.35013C17.1539 8.86498 17.5326 8.47123 17.9992 8.47123C18.4663 8.47123 18.8444 8.86498 18.8444 9.35013V16.8613Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
